import $ from 'jquery';

$('.offer__slider').each(function () {
    var $slider = $(this);

    $slider.slick({
        autoplay: true,
        autoplaySpeed: 7000,
        infinite: true,
        arrows: true,
        dots: false,
        draggable: true,
        rows: 0,
        prevArrow: '<button title="'+ window.translationStrings.prevSlide +'" class="slick-prev fa-thin fa-angle-left"></button>',
        nextArrow: '<button title="'+ window.translationStrings.nextSlide +'" class="slick-next fa-thin fa-angle-right"></button>',
        appendArrows: $('<div>', {class: 'offer__arrows'}).insertAfter($slider),
    });
});
